// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"791":"cb268f82","939":"e5a43cd8","940":"1a115d33"}[chunkId] + ".chunk.js";
};